import { api } from './setupApi';

class FigmaModel {
  link = '/figma_write';

  writeFigma = (data: { figmaKey: string }) => api.post(this.link, data);
}

export const figmaModel = new FigmaModel();
